import { ReactNode } from "react";
import { useTheme } from "@contexts/ThemeContext";

interface JarvisItemProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  color?: string;
  className?: string;
}

/** A count with its label. The colour, when given, marks the status with a small dot; the number stays ink. */
export default function JarvisItem({ label, value, color, className = "" }: JarvisItemProps) {
  const { colors } = useTheme();

  return (
    <div
      className={`flex items-center justify-between rounded-[10px] border px-4 py-3.5 ${className}`}
      style={{
        backgroundColor: colors.card,
        borderColor: colors.border,
      }}
    >
      <span className="flex items-center gap-2 text-[13px] font-medium" style={{ color: colors.textSecondary }}>
        {color && <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />}
        {label}
      </span>
      <span className="text-2xl font-semibold tabular-nums" style={{ color: colors.text }}>
        {value}
      </span>
    </div>
  );
}
